module.exports = __webpack_public_path__ + "img/page-intro-logo-baserow.d9c576d.svg";